import script from "./CountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountCard.vue?vue&type=script&setup=true&lang=ts"

import "./CountCard.vue?vue&type=style&index=0&id=3ce21372&scoped=true&lang=css"
script.__scopeId = "data-v-3ce21372"

export default script